<button
  *ngIf="'utah_UTAH-76_service_bell_widget' | featureFlag"
  class="lum-meta-menu-item"
  (click)="handleExpertSupportClick($event)"
>
  <i class="lum-meta-menu-item__icon fas fa-concierge-bell"></i>
  <span class="lum-meta-menu-item__text">Call an Expert</span>
</button>
<button
  *ngIf="isSearchEnabled"
  class="lum-meta-menu-item"
  (click)="handleSearchClick($event)"
  title="Search (Ctrl+K)"
>
  <i class="lum-meta-menu-item__icon fas fa-search"></i>
  <span class="lum-meta-menu-item__text">Search</span>
</button>
<button class="lum-meta-menu-item" id="luminous-intercom-toggle">
  <i class="lum-meta-menu-item__icon fas fa-question-circle"></i>
  <span class="lum-meta-menu-item__text">Help & Tutorials</span>
</button>
<lum-notification-dropout
  class="lum-meta-menu-item-group"
></lum-notification-dropout>
<kt-user-profile class="lum-meta-menu-item-group"></kt-user-profile>
